import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { LoadingSpinner } from '../../components'
import { getClientTokenPasswordless } from '../../utils/getClientToken'

type Props = {
  location: {
    search: string
  }
}

export default function BrowsePasswordless({ location: { search } }: Props): JSX.Element {
  const history = useHistory()

  useEffect(() => {
    ;(async () => {
      const params = new URLSearchParams(search)
      const error = params.get('error')
      if (error) {
        const errorDescription = params.get('error_description') || ''
        history.replace(
          `/sso/browse/callback/error?error_description=${encodeURIComponent(errorDescription)}`,
        )
      } else {
        const redirectUrl = params.get('redirect_url') || window.location.origin
        const clientToken = params.get('data')
        if (clientToken) await getClientTokenPasswordless(clientToken)
        window.location.replace(redirectUrl)
      }
    })()
  }, [])

  return (
    <div data-test="browse-passwordless">
      <LoadingSpinner />
    </div>
  )
}
